const REPORT_FIELD_TYPE = {
    NUMERIC: 'NUMERIC',
    PERCENT: 'PERCENT',
    MONEY: 'MONEY',
};

export default REPORT_FIELD_TYPE;
